import React, { useEffect } from "react";
import Pilots from "../components/Pilots/AllPilots";
 
import { Header, Footer } from "../shared";
// import Recruiters from "../components/jobsHirePage/Recruiters";

const DaasServicePage = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <div>
      <div className="bg_darkblue">
        <Header />
      </div>
      <Pilots />
      <Footer />
    </div>
  );
};

export default DaasServicePage;
